export function filterProps(props, allowed) {
  var ret = {};

  for (var key in props) {
    if (allowed[key]) {
      ret[key] = props[key];
    }
  }

  return ret;
}